export function truncateString(str: string | null | undefined, num: number): string {
    if (str == null || str == undefined) {
        return "";
    }
    var res = str.slice(0, num);
    if (str.length <= num) {
        return str;
    }
    else {
        return res.slice(0, res.length - 3) + "...";
    }
}

export function isValidUrl(value: string) : boolean {
  let url;
  
  try {
    url = new URL(value);
  } catch (_) {
    return false;  
  }
  return url.protocol === "http:" || url.protocol === "https:";
}